import React, { useEffect } from "react";
import useState from "react-usestateref";
import * as Icons from "@material-ui/icons";
import Pagination from "@material-ui/lab/Pagination";
import { CircularProgress, Typography } from "@material-ui/core";
import useStyles from "../components/Header/styles";
import apiService from "../core/service/detail";
import { getMethod } from "../core/service/common.api";
import { postMethod } from "../core/service/common.api";
// import { PdfImage } from '../images/PDF_file_icon.svg.png'
import PdfImage from "../images/PDF_file_icon.svg.png";
import moment from "moment";
import SearchBar from "./searchbar";
import Skeleton from "react-skeleton-loader";
import FromDatePicker from "./fromdatepicker";
import ToDatePicker from "./todatepicker";

function Carrer() {
  const [currentPage, setCurrentPage] = useState(1);
  const [getP2POrders, setgetAllp2pOrders, getP2POrdersref] = useState([]);
  const [pageloader, setpageloader] = useState(true);
  const [totalPage, setTotalpages] = useState(0);
  const [activefilter, setActivefilter] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [toDate, setToDate] = useState("");
  var classes = useStyles();
  const recordPerPage = 10;
  // total number of the records
  const totalRecords = 15;
  // range of pages in paginator
  const pageRange = 5;

  const handlePageChange = (pageNumber) => {
    getContacts(pageNumber);
    setCurrentPage(pageNumber);
    // setchoosepage()
  };

  useEffect(() => {
    getContacts();
  }, []);

  const getContacts = async (page, search = searchTerm) => {
    try {
      var payload = {
        perpage: 10,
        page: page,
        search: search,
        fromDate: fromDate,
        toDate: toDate,
      };
      var data = {
        apiUrl: apiService.careerdata,
        payload: payload,
      };
      setpageloader(true);
      var resp = await postMethod(data);
      setpageloader(false);
      if (resp.status) {
        console.log(resp.data.data, "resp.data.data");
        setgetAllp2pOrders(resp.data.data);
        setTotalpages(resp.data.pages);
      }
    } catch (error) {}
  };

  const handleFilterchange = async (e) => {
    setActivefilter(true);
    await getContacts(1);
  };

  const enquiry = async (e) => {
    try {
      var payload = {
        _id: e._id,
        status: "read",
      };
      var data = {
        apiUrl: apiService.changecareerstatus,
        payload: payload,
      };

      var resp = await postMethod(data);
      if (resp.status) {
        getContacts();
      } else {
      }
    } catch (error) {
      console.log("=-=-=-=-=-=-=-=-", error, "=-=-=-=-=-error-=-=");
    }
  };

  return (
    <>
      <div>
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
          <Typography
            fullWidth
            color="inherit"
            className={classes.blog_categories}
            variant="body2"
            sx={{ mt: 1 }}
          >
            Career
          </Typography>
          <div className="right_top">
            <SearchBar
              placeholder="Search by Name"
              className="mb-3"
              onSearch={(term) => {
                setSearchTerm(term);
              }}
            />

            <FromDatePicker
              placeholder="DD-MM-YYYY"
              onSearch={(date) => setFromDate(date)}
            />

            <ToDatePicker
              placeholder="DD-MM-YYYY"
              fromDate={fromDate}
              onSearch={(date) => setToDate(date)}
            />

            <div className="btn_add" onClick={() => handleFilterchange()}>
              <span>Filter</span>
              <Icons.FilterListSharp />
            </div>
          </div>
        </div>
        <div className="table_outer">
          <div className="table-responsive">
            <table class="table m-0 table-striped">
              <thead className="admin_thead">
                <tr>
                  <th> S.No</th>
                  <th> Profile Name </th>
                  <th> Email</th>
                  <th> Mobile Number</th>
                  {/* <th> Language </th> */}
                  <th> Experience </th>
                  <th> Date </th>
                  <th> Resume </th>
                  <th> Status </th>
                </tr>
              </thead>

              <tbody className="admin_tbody">
                {pageloader === true ? (
                  Array.from({ length: 10 }).map((_, i) => (
                    <tr key={i}>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                    </tr>
                  ))
                ) : getP2POrdersref.current.length > 0 ? (
                  getP2POrdersref.current.map((orders, i) => {
                    return (
                      <tr>
                        <td>{i + 1}</td>
                        <td>{orders.userName}</td>
                        <td>{orders.email}</td>
                        <td>{orders.mobileNumber}</td>
                        {/* <td>{orders.language}</td> */}
                        <td>{orders.experience}</td>
                        <td>{moment(orders.createdAt).format("lll")}</td>
                        <td>
                          <img
                            style={{ width: "20px", marginRight: "10px" }}
                            src={PdfImage}
                          />
                          <a href={orders.resume} target="_blank">
                            {" "}
                            View{" "}
                          </a>
                        </td>
                        <td>
                          {orders.status == "" ? (
                            <p
                              className="mb-0"
                              style={{ color: "green" }}
                              onClick={() => enquiry(orders)}
                            >
                              {" "}
                              Open{" "}
                            </p>
                          ) : (
                            <p className="mb-0" style={{ color: "red" }}>
                              {" "}
                              Closed{" "}
                            </p>
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr className="no-record">
                    <td colSpan={9}>
                      <div className="emptyrecordimg">
                        <img
                          src={require("../images/No-data.webp")}
                          width="100px"
                        />
                        <span className="emptyrecord">No records found</span>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {totalPage > 1 && (
          <Pagination
            count={totalPage}
            page={currentPage}
            onChange={(e, value) => handlePageChange(value)}
            className={`${classes.blog_pagination} mt-4`}
            color="primary"
            shape="rounded"
          />
        )}

        {/* <Pagination
        itemClass="page-item" // add it for bootstrap 4
        linkClass="page-link" // add it for bootstrap 4
        activePage={currentPage}
        itemsCountPerPage={recordPerPage}
        totalItemsCount={totalPage}
        pageRangeDisplayed={pageRange}
        onChange={handlePageChange}
      /> */}
      </div>
    </>
  );
}

export default Carrer;
